export default "__VITE_PUBLIC_ASSET__2cdaa2f7__"